import type { DocumentRenameDropdownMenuItemFragment } from "../client/generated";
import { useState } from "react";
import { DropdownMenuItem } from "@acdc2/ui/components/dropdown-menu";
import { Icon } from "@mdi/react";
import { mdiPencil } from "@mdi/js";
import { useTranslation } from "react-i18next";
import { DocumentRenameDialogContent } from "./DocumentRenameDialogContent";
import { Dialog, DialogTrigger } from "@acdc2/ui/components/dialog";

type Props = {
  fragment: DocumentRenameDropdownMenuItemFragment;
};

export function DocumentRenameDropdownMenuItem({ fragment }: Props) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger data-testid="document-rename-dropdown-menu-item" asChild>
        <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
          <Icon path={mdiPencil} size="1.25rem" />
          {t("DocumentRenameDropdownMenuItem.label")}
        </DropdownMenuItem>
      </DialogTrigger>
      <DocumentRenameDialogContent
        fragment={fragment}
        onDone={() => setIsOpen(false)}
      />
    </Dialog>
  );
}
